module.exports = __webpack_public_path__ + "media/images/webpage/coupons/new_registration/howto-complete-7c57ff705a1edd94a30817b64b5e58c4.webp";